import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
const TransDetailsByItemSubTab = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [25, 50, 100, 500, 1000, "all"];
    const gridKey = "3437EFEA-FEF6-4018-AFDC-70974427E57D";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="none" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={25} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
                <FilterRow visible={true} />
                <Scrolling mode="virtual" />
                <Column dataField="transactionType" caption="Transaction Type" visible={true} />
                <Column dataField="transactionNumber" caption="Transaction Number" visible={true} />
                <Column dataField="shipperBolNumber" caption="Shipper BOL Number" visible={true} />
                <Column dataField="transactionDate" caption="Transaction Date" visible={true} />
                <Column dataField="reference" caption="Reference" visible={true} />
                <Column dataField="lotCode" caption="Lot Code" visible={true} />
                <Column dataField="lotDescription" caption="Lot Description" visible={true} />
                <Column dataField="quantityOrder" caption="Quantity Ordered" visible={true} />
                <Column dataField="quantityActual" caption="Quantity Actual" visible={true} />
                <Column dataField="amount" caption="Amount" visible={true} />
                <Column dataField="itemCode" caption="Item Code" visible={false} />
                <Column dataField="itemDescription" caption="Item Description" visible={false} />
                <Column dataField="customerId" caption="Customer ID" visible={false} />
                <Column dataField="customerName" caption="Customer Name" visible={false} />
                <Column dataField="deliveryPickupPlannedDateTime" caption="Delivery Pickup Planned Date" visible={false} />
                <Column dataField="deliveryPickupArrivedDateTime" caption="Delivery Pickup Arrived Date" visible={false} />
                <Column dataField="plannedReceivedShippedDateTime" caption="Planned Received Shipped Date" visible={false} />
                <Column dataField="stagingStartDate" caption="Staging Start Date" visible={false} />
                <Column dataField="stagingEndDate" caption="Staging End Date" visible={false} />
                <Column dataField="unloadPickByPlanDate" caption="Unload Pick By Plan Date" visible={false} />
                <Column dataField="checkByPlanDate" caption="Check By Plan Date" visible={false} />
                <Column dataField="putawayByPlanDate" caption="Putaway By Plan Date" visible={false} />
                <Column dataField="deliveryPickupDepartDateTime" caption="Delivery Pickup Depart Date" visible={false} />
                <Column dataField="truckArrivalDateTime" caption="Truck Arrival Date" visible={false} />
                <Column dataField="truckDepartDateTime" caption="Truck Depart Date" visible={false} />
                <Column dataField="transportationYardLeaveDate" caption="Transportation Yard Leave Date" visible={false} />
                <Column dataField="fmTruckReference" caption="FM Truck Reference" visible={false} />
                <Column dataField="fmDriverReference" caption="FM Driver Reference" visible={false} />
                <Column dataField="fmTrailerReference" caption="FM Trailer Reference" visible={false} />
                <Column dataField="dockYardWarehouseId" caption="Dock Yard Warehouse ID" visible={false} />
                <Column dataField="dockYardLocationCode" caption="Dock Yard Location Code" visible={false} />
                <Column dataField="transportDriverId" caption="Transport Driver ID" visible={false} />
                <Column dataField="transportDriverName" caption="Transport Driver Name" visible={false} />
                <Column dataField="transportTrailerId" caption="Transport Trailer ID" visible={false} />
                <Column dataField="transportTruckId" caption="Transport Truck ID" visible={false} />
                <Column dataField="shipperId" caption="Shipper ID" visible={false} />
                <Column dataField="consigneeId" caption="Consignee ID" visible={false} />
                <Column dataField="shipperName" caption="Shipper Name" visible={false} />
                <Column dataField="consigneeName" caption="Consignee Name" visible={false} />
                <Column dataField="status" caption="Status" visible={false} />
                <Column dataField="fiscalYear" caption="Fiscal Year" visible={false} />
                <Column dataField="fiscalPeriod" caption="Fiscal Period" visible={false} />
                <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(TransDetailsByItemSubTab);